import { Task } from '@lit/task';
import { ReactiveController, ReactiveControllerHost } from 'lit';
import { getUserInfo, getUserSiteConfigs } from '../services/menu-data-store';
import { SiteAccessibility, UserInformation } from '../types';

/**
 * Responsible for fetching and providing Site Selector data
 */
export class SitesDataController implements ReactiveController {
  private host: ReactiveControllerHost;

  public sitesData: SiteAccessibility[] = [];

  public userInfo?: UserInformation;

  constructor(host: ReactiveControllerHost) {
    (this.host = host).addController(this);
  }

  public hostConnected() {
    this.initSitesData();
  }

  private initSitesData() {
    new Task<[], void>(
      this.host,
      async () => {
        this.sitesData = await getUserSiteConfigs();
        this.host.requestUpdate();
      },
      () => [],
    );

    new Task<[], void>(
      this.host,
      async () => {
        this.userInfo = await getUserInfo();
        this.host.requestUpdate();
      },
      () => [],
    );
  }
}
